import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from '../../../styles'
import { makeStyles } from '@material-ui/core/styles'
import Button from '../../../components/button/Button'
import { useHistory } from 'react-router'
import links from '../../../enums/linksEnum'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme)
        }
    )
)

const EmptyContracts = () => {
    const classes = useStyle()
    const history = useHistory()

    const seeContracts = () => {
        history.push(links.contracts)
    }

    return (
        <div>
            <h1
                className={classes.text3}
            >
                <FormattedMessage
                    id="dashboard.contracts.emptyContractsText"
                    defaultMessage="Vous ne disposez d'aucun contrat actif"
                    description="Dashboard empty contract text"
                />
            </h1>

            <Button
                color="colorWhite"
                onClick={seeContracts}
                background="backgroundDynamic"
                textStyle="text4"
                size="mediumButton"
                type="button"
            >
                <FormattedMessage
                    id="dashboard.contracts.emptyContractsLink"
                    defaultMessage="Consulter vos contrats clôturés"
                    description="Dashboard empty contract link"
                />
            </Button>
        </div>
    )
}

export default EmptyContracts
